import { forwardRef } from 'react';

import Icon from '../icon';

import NextStepSvgIcon from './next-step.svg?react';

/* This file is autogenerated, see readme.md for instructions */
import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

/**
 * @deprecated This icon has been removed from the @bloomreach/banana-theme package.
 * Please don't use it anymore. It will be removed in the next major version.
 */
const NextStepIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <NextStepSvgIcon />
    </Icon>
  );
});

NextStepIcon.displayName = 'NextStepIcon';

export default NextStepIcon;
